export const steps = {
  Marketplace: [
    {
      target: ".tourMarketPlaceUploadMachine",
      title: "Upload my machine",
      content:
        "Click Upload My Machine to add your own machine to the platform. Follow the steps to configure details, set pricing, and make it available for others to explore and use.",
      disableBeacon: true,
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      // height: "29px",
      // width: "147px",
      // className: "",
    },
    {
      target: ".tourMarketPlaceMachineIcon",
      title: "Machine Icon",
      content:
        "The icon represents the machine type or category for easy identification.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourMarkePlaceMachineDetail",
      title: "Machine Name",
      content:
        "The name and rating help you quickly assess the machine's quality, while the short description provides essential details.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourMarketPlaceDevName",
      title: "Developer Name",
      content:
        "See who developed this machine to understand the expertise behind it.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    // {
    //   target: ".tourMarketPlaceMachinePrice",
    //   title: "Machine Pricing",
    //   content:
    //     "Check the pricing to evaluate the cost of the machine before exploring further.",
    //   placement: "right",
    //   customProp: {
    //     classname: "position-right",
    //   },
    // },
    // {
    //   target: ".tourMarketPlaceExploreBtn",
    //   title: "Explore Button",
    //   content:
    //     "Click the ‘Explore’ button for more in-depth details, including general information, parameters, versions, review & ratings, FAQs, sample data",
    //   placement: "right",
    //   customProp: {
    //     classname: "position-right",
    //   },
    // },
    {
      target: ".tourMarketPlaceFilterIndustry",
      title: "Filter Industry",
      content:
        "Filter machines based on industry categories to find the best fit for your needs.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
  ],
  MarketplaceWorkflow: [
    {
      target: ".tourMarketPlaceMachineIcon",
      title: "Machine Icon",
      content:
        "The icon represents the machine type or category for easy identification.",
      placement: "right",
      disableBeacon: true,
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourMarkePlaceMachineDetail",
      title: "Machine Name",
      content:
        "The name and rating help you quickly assess the machine's quality, while the short description provides essential details.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourMarketPlaceDevName",
      title: "Developer Name",
      content:
        "See who developed this machine to understand the expertise behind it.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    // {
    //   target: ".tourMarketPlaceMachinePrice",
    //   title: "Machine Pricing",
    //   content:
    //     "Check the pricing to evaluate the cost of the machine before exploring further.",
    //   placement: "right",
    //   customProp: {
    //     classname: "position-right",
    //   },
    // },
    // {
    //   target: ".tourMarketPlaceExploreBtn",
    //   title: "Explore Button",
    //   content:
    //     "Click the ‘Explore’ button for more in-depth details, including general information, parameters, versions, review & ratings, FAQs, sample data",
    //   placement: "right",
    //   customProp: {
    //     classname: "position-right",
    //   },
    // },
    {
      target: ".tourMarketPlaceFilterIndustry",
      title: "Filter Industry",
      content:
        "Filter machines based on industry categories to find the best fit for your needs.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
  ],
  Addmachine: [
    {
      target: ".tourAddMachineZip",
      title: "Upload Machine Icon & Zip File",
      content:
        "Drag and drop or click to upload your machine’s icon and ZIP file. The icon will represent the machine, and the ZIP file holds its data.",
      disableBeacon: true,
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      className: "upload-machine-data",
    },
    {
      target: ".tourAddMachineBannerImage",
      title: "Upload Banner Images",
      content:
        "Drag and drop or click to upload banner images for your machine. These images will be shown as the machine's banners.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourAddMachineOverview",
      title: "Overview",
      content:
        "Start by providing a brief overview of your machine to give a clear description.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      className: "upload-machine-overview",
    },
    {
      target: ".tourAddMachineClassification",
      title: "Classification",
      content:
        "Classify your machine to help categorize it for easy identification.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
      className: "upload-machine-classification",
    },
    {
      target: ".tourAddMachineCompAndDep",
      title: "Compatibility and Dependencies",
      content:
        "Specify the machine’s compatibility and any dependencies it may have with other systems or tools.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourAddMachineSpecAndSample",
      title: "Specifications and Sample Data",
      content:
        "Enter the machine's specifications and upload any relevant (required inputs and produced outputs) sample data for better clarity.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourAddMachineInfra",
      title: "Infrastructure Requirement",
      content:
        "Outline the infrastructure requirements needed to support your machine.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourAddMachineParaConfig",
      title: "Parameter Configuration",
      content:
        "Click Add Parameter button to add new parameters. Simply fill in the required fields and save your changes to update your configuration.",
      placement: "left",
      customProp: {
        classname: "position-left",
      },
    },
    {
      target: ".tourAddMachineFaq",
      title: "FAQs",
      content:
        "Click the Add FAQ button. Fill in the question and answer fields, then save to include the FAQ in the machine's details.",
      placement: "left",
      customProp: {
        classname: "position-left",
      },
    },
  ],
  Workflow_Dashboard: [
    {
      target: ".tourWorkFlowDashboardTab",
      title: "List & Card View",
      content: "Switch Between List and Card View",
      disableBeacon: true,
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardAdd",
      title: "Add Workflow",
      content:
        "Start creating a new workflow by clicking Add. Enter key details like Industry, Workflow Name, and Description. Click Submit to complete setup, design workflow, configure machines and view the workflow’s progress!",
      placement: "left",
      customProp: {
        classname: "position-left",
      },
    },
    {
      target: ".tourWorkFlowDashboardName",
      title: "Workflow Name",
      content:
        "Click the workflow name to access the Workflow Engineering Screen and make detailed adjustments.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardStatus",
      title: "Status Indicator",
      content:
        "View the current status of this workflow, such as Active, Paused, or Error.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardSchedular",
      title: "Scheduler",
      content:
        "See or adjust the schedule for your workflow, setting specific run times as needed.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardNotification",
      title: "Notification Settings",
      content:
        "Configure notifications to stay updated on this workflow’s activity and status changes.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardLog",
      title: "Logs",
      content:
        "Access logs to view the detailed history of actions and events for this workflow.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardView",
      title: "View Workflow",
      content:
        "Preview this workflow’s settings and current status without making changes.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardEdit",
      title: "Edit Workflow",
      content: "Click to edit workflow details, settings, and configuration.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardDelete",
      title: "Delete Workflow",
      content: "Remove this workflow if it’s no longer needed.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardRunSummary",
      title: "Run Summary",
      content:
        "See the number of successful and failed runs along with timestamps for easy tracking.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardMachines",
      title: "Machines",
      content:
        "View the machines associated with this workflow and their statuses.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardBillingInfo",
      title: "Billing Information",
      content:
        "Review billing details related to this workflow’s usage and cost.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardLastRun",
      title: "Last Run",
      content: "Check when the workflow last ran to monitor recent activity.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardNextRun",
      title: "Next Scheduled Run",
      content:
        "See the upcoming scheduled run time, so you know when it will execute next.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardGraph",
      title: "Resource Usage Graphs",
      content:
        "Monitor system resource usage—CPU, Memory, and Network—to ensure optimal performance.",
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkFlowDashboardCost",
      title: "Cost",
      content:
        "Track your workflow costs with insights on the current month, last month, average monthly expenses, forecasted costs, and the percentage change from last month to optimize spending.",
      placement: "left",
      customProp: {
        classname: "position-left",
      },
    },
  ],
  Workflow_Engineering: [
    {
      target: ".tourWorkflowMachines",
      title: "Machines",
      content:
        "Search or browse machines by category and drag them from here to build your workflow. Also, Explore marketplace to buy and add new machines if required.",
      disableBeacon: true,
      placement: "right",
      customProp: {
        classname: "position-right",
      },
    },
    {
      target: ".tourWorkflowName",
      title: "Workflow Name",
      content:
        "Give your workflow a unique name, then click 'Save' to keep your design.",
      placement: "bottom",
      customProp: {
        classname: "position-bottom",
      },
    },
    {
      target: ".tourWorkflowCollaborators",
      title: "Collaborators",
      content:
        "Add members to collaborate on this workflow by assigning them role that fits them best. You can also update designations or remove members as needed to keep your team organized.",
      placement: "bottom",
      customProp: {
        classname: "position-bottom",
      },
    },
    {
      target: ".tourWorkflowNotifications",
      title: "Notifications",
      content:
        "Stay updated with important alerts and reminders. Click here to view your notifications and keep track of recent activities.",
      placement: "bottom",
      customProp: {
        classname: "position-bottom",
      },
    },
    {
      target: ".tourWorkflowSchedular",
      title: "Scheduler",
      content:
        "Easily schedule workflows by setting the time and frequency to automate tasks.",
      placement: "bottom",
      customProp: {
        classname: "position-bottom",
      },
    },
    {
      target: ".tourWorkflowCostAndUsgae",
      title: "Cost & Usage",
      content:
        "Track your costs and usage in real-time to monitor your spending and optimize resources.",
      placement: "bottom",
      customProp: {
        classname: "position-bottom",
      },
    },
    {
      target: ".tourWorkflowLogs",
      title: "Logs",
      content:
        "View detailed logs of your workflows to track progress, identify issues, and ensure smooth operation.",
      placement: "left",
      customProp: {
        classname: "position-cross-right",
      },
    },
    {
      target: ".tourWorkflowMachineSetup",
      title: "Machine Setup",
      content: "Set up your machine by configuring its necessary settings.",
      placement: "left",
      customProp: {
        classname: "position-left",
      },
    },
    {
      target: ".tourWorkflowStatus",
      title: "Status",
      content:
        "View workflow status indicators and the scheduled next run here. Use Run Now or Suspend buttons to control the workflow manually. Monitor CPU, memory and network usage to keep track of performance.",
      placement: "left",
      customProp: {
        classname: "position-left",
      },
    },
    {
      target: ".tourWorkflowCostSummary",
      title: "Cost Summary",
      content:
        "Review the cost summary to understand expenses related to your workflow, helping you manage and optimize budget efficiently.",
      placement: "left",
      customProp: {
        classname: "position-left",
      },
    },
    {
      target: ".tourWorkflowAI",
      title: "AI-Enhnaced Machine",
      content:
        "Explore AI-powered machine recommendations tailored to optimize your workflow and enhance performance.",
      placement: "top",
      customProp: {
        classname: "position-top",
      },
    },
  ],
};
